export const config = {
    movistarDominio: process.env.REACT_APP_MOVISTAR_DOMINIO,
    geoIpService: `${process.env.REACT_APP_APIFY}/getip`,
    recaudoService: process.env.REACT_APP_BASE_DOMAIN_RECAUDO,
    sessionIdService: `${process.env.REACT_APP_BASE_DOMAIN_RECAUDO}/api/recaudo/checkout/sessionid`,
    tokenService: `${process.env.REACT_APP_BASE_DOMAIN_RECAUDO}/api/recaudo/get/token`,
}